import React from "react";
import { useNavigate } from 'react-router-dom';

export const CardLinea = (props) =>{
    const navigate = useNavigate();

    const goToLinea = async (lineName) => {
        navigate('/Linea/'+lineName);
    };

    // Obtener la ruta de la imagen (puede ser URL de Firebase o ruta local)
    const getImagePath = () => {
        if (props.image) {
            // Si es una URL (Firebase Storage), usarla directamente
            if (props.image.startsWith('http://') || props.image.startsWith('https://')) {
                return props.image;
            }
        }
        // Si no hay imagen configurada, usar el icono como fallback
        if (props.icon) {
            try {
                return require('../../assets/icons-lineas/' + props.icon);
            } catch (e) {
                return require('../../assets/not_found.jpg');
            }
        }
        // Imagen por defecto
        return require('../../assets/not_found.jpg');
    };

    return(
            <div className="p-2 col-md-4">
                <section id={props.name}>
                    <div onClick={() => goToLinea(props.name) } className={`card-linea-container ${props.color }`}>
                        <a className="icon-card-linea" href="#Alumnos">
                            <img src={getImagePath()} alt="Linea de investigacion"/>
                        </a>
                        <h2 className="name-of-line text-center">{props.name}</h2>
                    </div>
                </section>
            </div>
    )   
}